import { getPromotionGiftMeta, normalizeSiteLines } from "../../Promotion/components/promotionGiftMappers";

function hasRecipient(value) {
  return typeof value === "string" ? value.trim().length > 0 : Boolean(value);
}

function buildExpiryText(dateText, fallback) {
  if (!dateText) {
    return fallback;
  }

  return `만료일: ${dateText}`;
}

export function mapGiftTicketItem(item) {
  const meta = getPromotionGiftMeta("gift-ticket");

  return {
    type: "gift-ticket",
    itemName: item?.name || "",
    imageUrl: item?.image || "",
    senderName: item?.sender || "",
    remainingCount: 0,
    siteLines: normalizeSiteLines(item?.site_name ? [item.site_name] : []),
    validityText: buildExpiryText(item?.expiration_date, meta.defaultValidity),
    noticeHtml: item?.descript || "",
    isReceived: hasRecipient(item?.recipient),
  };
}

export function mapGiftVoucherItem(item) {
  const meta = getPromotionGiftMeta("gift-voucher");

  return {
    type: "gift-voucher",
    itemName: item?.name || "",
    imageUrl: item?.image || "",
    senderName: item?.sender || "",
    remainingCount: 0,
    siteLines: normalizeSiteLines(item?.site_name ? [item.site_name] : []),
    validityText: buildExpiryText(item?.expire_date, meta.defaultValidity),
    noticeHtml: item?.precautions || "",
    isReceived: hasRecipient(item?.recipient),
  };
}

export function mapGiftCouponItem(item) {
  const meta = getPromotionGiftMeta("gift-coupon");

  return {
    type: "gift-coupon",
    itemName: item?.coupon_name || item?.coupon?.title || "",
    imageUrl: item?.coupon?.image || "",
    senderName: item?.sender_username || item?.sender?.username || "",
    remainingCount: 0,
    siteLines: [],
    validityText: buildExpiryText(item?.expire_date, meta.defaultValidity),
    noticeHtml: item?.coupon?.descript || "",
    isReceived: Boolean(item?.user),
  };
}

export function mapGiftReservationItem(item) {
  const meta = getPromotionGiftMeta("gift-reservation");

  let validityText = meta.defaultValidity;
  if (item?.reservationDate && item?.reservationEndDate && item.reservationDate !== item.reservationEndDate) {
    validityText = `예약일: ${item.reservationDate} ~ ${item.reservationEndDate}`;
  } else if (item?.reservationDate) {
    validityText = `예약일: ${item.reservationDate}`;
  }

  return {
    type: "gift-reservation",
    itemName: item?.name || "",
    imageUrl: item?.image || "",
    senderName: item?.sender || "",
    remainingCount: 0,
    siteLines: normalizeSiteLines(item?.site_name ? [item.site_name] : []),
    validityText,
    noticeHtml: item?.descript || "",
    isReceived: hasRecipient(item?.recipient),
  };
}
